exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".testimonial-quote{text-align:center}.testimonial-quote blockquote{font-size:14px;line-height:1.5;margin-bottom:14px}.testimonial-quote blockquote::before{content:\"\";display:block;margin:0 auto 14px auto;background:url(\"/assets/images/quote.svg\") center center no-repeat;background-size:21px 21px;width:21px;height:21px}@media(min-width: 64.063em){.testimonial-quote blockquote{font-size:18px}}.testimonial-quote cite{display:block;font-size:10px;font-style:normal;text-transform:uppercase}.testimonial-quote cite.author{font-weight:600}@media(min-width: 64.063em){.testimonial-quote cite{font-size:12px}}", ""]);

// exports
